let contentObj = {}

if (typeof window === 'object') {
  const initI18n = require('@/lang')
  const i18n = initI18n.getI18n()

  /* 路由 */
  const routes = [
    {
      path: '/',
      name: 'Home',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      meta: {
        label: i18n.t('alarmCenter')
      },
      component: () => import('@/views/dataCenter/dataCenter')
    },
    {
      path: '/noPermissions',
      name: 'noPermissions',
      meta: {
        label: `403 (${i18n.t('noPermission')}`
      },
      component: () => import('@/views/noPermissions/noPermissions')
    }
  ]
  contentObj = {
    routes
  }
}
const componentsContent = {
  /* 指挥调度页面 */
  dataCenter: 'dataCenter_v3_ningxiazhongweiOfflineMap',
  leftData: 'leftData_v3_ningxiazhongwei',
  sevenDayData: 'sevenDayData_v3_ningxiazhongwei',
  fileData: 'fileData_v3_ningxiazhongwei'
}
/* 组件样式 */
const componentsStyle = {}
const assetsUrl = 'src/assets/tiantong'

module.exports = {
  ...contentObj,
  assetsUrl,
  componentsContent,
  componentsStyle
}
